<template lang="pug">
  app-toolbar(title="События и заметки")
    app-toolbar-item(label="Период") 
      .toolbar-button(@click="dialog.pickDate = true") {{ formattedPeriod }}
    app-toolbar-item.ml-12(label="Вид календаря" :items="calendarTypes" key-name="name" @select="reloadEventsWithPeriodType") {{ period.type.name }}
    app-toolbar-item.ml-12(label="Показать" :items="tags" key-name="hashtag" all="все" @select="setTag") {{ tag ? tag.hashtag : "все" }}

    app-dialog(v-model="dialog.pickDate" header="Период" confirm-text="далее" @confirm="closeWithSelectedPeriod")
      app-date-picker(v-model="selectedPeriod" :format="periodFormat" :view-format="periodFormat" :type="periodType" label="Выберите период")
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import moment from '@/common/AppMoment.js'

export default {
  computed: {
    ...mapState('event', ['tag', 'tags', 'period']),
    ...mapGetters('event', ['periodStart', 'periodEnd', 'calendarTypes']),

    formattedPeriod () {
      return this.period.type.isMonth 
      ? moment(this.period.date).format('MMMM YYYY') 
      : `${moment(this.periodStart).format('D.MM')} - ${moment(this.periodEnd).format('D.MM.YYYY')}`
    },

    periodType () {
      return this.period.type.isMonth ? 'month' : 'date'
    },

    periodFormat () {
      return this.period.type.isMonth ? 'MMMM YYYY' : 'Неделя WW YYYY года'
    },
  },

  methods: {
    ...mapMutations('event', ['setTag']),
    ...mapActions('event', ['reloadEventsWithPeriodType', 'reloadEventsWithPeriodDate']),

    closeWithSelectedPeriod () {
      let p = moment(this.selectedPeriod, this.periodFormat)
      this.reloadEventsWithPeriodDate(p)
    },
  },

  data () {
    return {
      dialog: {
        pickDate: false,
      },
      selectedPeriod: null,
    }
  },
}
</script>